module.exports = __webpack_public_path__ + "img/FINANCEPR4.9b89fb54.png";